import React, { FC } from 'react';
import { Content } from '../../components/content';
import { Header } from '../../components/header/header';
import { Page } from '../../components/page';
import { SHIP_TO_ID_PARAM } from '../../constants/routes';
import { IOrder, IShipTo, ISoldTo, Status } from '../../graphql/types';
import { OrdersBody } from './body';
import { GetOrdersByPurchaseOrderQuery } from './queries/orders-by-po';
import { ORDERS_PAGE_ROUTE } from './route';
import { SoldToTopSection } from './top-section';

export const PURCHASE_ORDER_PARAM = 'purchaseOrder';

export interface IOrdersByPurchaseOrderNumber {
  [SHIP_TO_ID_PARAM]?: string;
  [PURCHASE_ORDER_PARAM]: string;
  status?: string;
  vessel?: string;
}

interface IOrdersByPurchaseOrderNumberProps
  extends Omit<IOrdersByPurchaseOrderNumber, 'status'> {
  soldToId: string;
  statuses: Status[];
  vesseles: string[];
}

export const OrdersByPurchaseOrderNumberPage: FC<IOrdersByPurchaseOrderNumberProps> = ({
  soldToId,
  purchaseOrder,
  shipToId,
  statuses,
  vesseles,
}) => {
  return (
    <Page
      data-type="page"
      data-page={ORDERS_PAGE_ROUTE}
      data-sold-to-id={soldToId}
      data-purchase-order={purchaseOrder}
      data-ship-to-id={shipToId}
    >
      <Header />
      <Content>
        <GetOrdersByPurchaseOrderQuery
          soldToId={soldToId}
          shipToId={shipToId}
          poId={purchaseOrder}
          render={(
            orders: IOrder[],
            soldTo: ISoldTo | null,
            shipTo?: IShipTo
          ) => {
            return (
              <>
                {soldTo && <SoldToTopSection soldTo={soldTo} shipTo={shipTo} />}
                <OrdersBody
                  soldToId={soldToId}
                  orders={orders}
                  statuses={statuses}
                  showDatePill={false}
                  vesseles={vesseles}
                />
              </>
            );
          }}
        />
        )
      </Content>
    </Page>
  );
};
